<template>
  <router-view />
</template>

<style lang="scss">
:root {
  --color-subcolor: #3b263ac2;
  --border-color: #eee;
  --bg-color: #fff;
  --text-color: #333;
  --chat-card-bg-color: #f3f3f3;
}
html.dark {
  --color-subcolor: #acacac;
  --border-color: #4c4d4f;
  --bg-color: #1f1f1f;
  --text-color: #eee;
  --chat-card-bg-color: #2c2d2e;
}
body {
  margin: 0;
  color: var(--text-color);
}
p {
  margin: 0;
}
</style>
